import { motion, AnimatePresence } from "framer-motion";

interface ParticipantsProps {
  participants?: string[];
}

export const Participants = ({ participants = [] }: ParticipantsProps) => {
  return (
    <motion.div
      className="flex items-center justify-center overflow-visible"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        className="text-center overflow-visible flex flex-col gap-1"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        {/* Participants List */}
        <AnimatePresence mode="popLayout">
          {[...participants]
            .reverse()
            .slice(0, 10)
            .map((username, index) => (
              <motion.span
                key={`${username}-${participants.length - index}`}
                initial={{ opacity: 0, scale: 0, y: -20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.5, x: 100 }}
                transition={{
                  type: "spring",
                  stiffness: 400,
                  damping: 25,
                }}
                layout
                className="text-2xl font-black uppercase tracking-wider overflow-visible"
                style={{
                  background:
                    "linear-gradient(135deg, hsl(45, 100%, 60%) 0%, hsl(25, 100%, 50%) 50%, hsl(5, 90%, 45%) 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  filter:
                    "drop-shadow(0 0 15px hsl(25, 100%, 50%)) drop-shadow(0 0 30px hsl(5, 90%, 40%))",
                }}
              >
                {username}
              </motion.span>
            ))}
        </AnimatePresence>
      </motion.div>
    </motion.div>
  );
};
